(function (angular, schoolwork12) {
    
    'use strict';

var app = angular.module('schoolwork12.studentTabContent', ['ngRoute', 'ngTouch', 'ngAria', 'ui.grid', 'ui.grid.pagination', 'ui.grid.cellNav', 'ui.grid.edit', 'ui.grid.resizeColumns', 'ui.grid.pinning', 'ui.grid.selection', 'ui.grid.moveColumns', 'ui.grid.exporter', 'ui.grid.importer', 'ui.grid.grouping'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/studentTabContent', {
    templateUrl: 'studentTabContent/studentTabContent.html',
    controller: 'StudentTabContentCtrl',
    controllerAs: 'GridCtrl'
  });
}])

.factory('SamsRestService', ['$http', '$q', function($http, $q){
   // var baseUrl = 'http://localhost:9090/schoolwork12/student';
 
    var baseUrl = schoolwork12.app.url.concat('/student');
    
    function authenticate() {
 
           var deferred = $q.defer();
           var data = 'grant_type=password&username=&password=&appname=restdemo';
 
           var request = $http({
              method: 'POST',
              url: baseUrl + '/token',
              data: data,
              headers: {
                'Accept': '*/*',
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            });
 
            request.then(function(response){
              var authToken = response.data.token_type + ' ' + response.data.access_token;
              $http.defaults.headers.common['Authorization'] = authToken;
              deferred.resolve(authToken);
            }, function(error){
              deferred.reject(error);
            });
 
            return deferred.promise;
          }
 
      function createStudent(body) {
 
            var request = $http({
              method: 'POST',
              data: body,
              url: baseUrl + '/student'
            });
 
            return sendRequest(request);
         }
 
     function getStudents() {

        var request = $http({
          method: 'GET',
          url: baseUrl + '/search?pageLimit=100&schoolIds=1005'
        });

        return sendRequest(request);
     }
    
     function updateStudent(id, body) {
 
            var request = $http({
              method: 'PUT',
              data: body,
              url: baseUrl + '/student/' + id
            });
 
            return sendRequest(request);
         }
 
     function deleteStudent(id) {

        var request = $http({
          method: 'DELETE',
          url: baseUrl + '/student/' + id
        });

        return sendRequest(request);
     }
    
     function sendRequest(config){
 
            var deferred = $q.defer();
 
            config.then(function(response){
              deferred.resolve(response);
            }, function(error){
              deferred.reject(error);
            });
 
            return deferred.promise;
         }
      return {
        authenticate: authenticate,
        createStudent: createStudent,
        getStudents: getStudents,
        updateStudent: updateStudent,
        deleteStudent: deleteStudent
      };
}])

.controller('StudentTabContentCtrl', ['$scope', 'SamsRestService','uiGridConstants', function($scope, samsRestService, uiGridConstants) {
   
    var tvssourl = 'http://192.168.1.12:5000/cgi-bin/WebObjects/TotalViewVA.woa/wa/k12KeycodeLogin?keyCode=P9Q9C9C909G97-I9I97-J-W-89L-9---L-G9D9I97-G9M97-29L-U99-F99-9-3-K-W-I929C9I9N9&pageName=studentEdit&studentId=';
    
    $scope.students = [];
    //{"familyID":59282,"lastName":"Tjvwufg","firstName":"Brianna","homePhone":"6466606878","email":"qatestemail@k12.com","schoolName":"Arizona Virtual Academy","schoolAbbreviation":"AZVA","schoolID":1020,"enrolledDate":{"millis":86529099600000,"dbsysDate":false},"studentID":75534,"gradeLevel":"K","status":0}
    
    $scope.gridOptions = {
        data: 'students',
        
        enableSorting: true,
        enableFiltering: true,
        enableGridMenu: true,
        enableCellEditOnFocus: true,
        
        showGridFooter: true,
        showColumnFooter: true,
        
        enablePaginationControls: true,
        paginationPageSize: 25,
        
        paginationPageSizes: [25, 50, 75],
        
        
        columnDefs: [
              {
               field: 'studentID',
                displayName: 'Student ID',
                width: 90,
                enableCellEdit: false,
                cellTooltip: function(row,col) {
                  return 'firstName: ' + row.entity.firstName + ', lastName: ' + row.entity.lastName + "status: " + row.entity.status;
                },
                headerTooltip: function (col) {
                    return 'Header: ' + col.displayName;
                },
                cellTemplate: 
                  '<div class="ui-grid-cell-contents"><a target="TVSchool" href=' + tvssourl + '{{row.entity.studentID}} title="{{row.entity.firstName}}">{{ row.entity.studentID }} </a></div>'
            },
            {
                field: 'familyID',
                displayName: 'Family ID',
                width: 90,
                enableCellEdit: true,
                cellTooltip: false
            },
            {
                field: 'lastName',
                displayName: 'Last Name',
                width: 120,
                enableCellEdit: false
            },
            {
                field: 'firstName',
                displayName: 'First Name',
                width: 120,
                enableCellEdit: false
            },
            {
                field: 'homePhone',
                displayName: 'Home Phone',
                width: 120,
                enableCellEdit: false
            },
            {
                field: 'email',
                displayName: 'Email',
                width: 180,
                enableCellEdit: false
            },
            {
                field: 'schoolName',
                displayName: 'School Name',
                width: 220,
                enableCellEdit: false
            },
            {
                field: 'schoolAbbreviation',
                displayName: 'School Abbreviation',
                width: 130,
                enableCellEdit: false
            },
            {
                field: 'schoolID',
                displayName: 'School ID',
                width: 90,
                enableCellEdit: false
            },
            {
                field: 'enrolledDate',
                displayName: 'Enrollment Date',
                width: 180,
                enableCellEdit: false,
                cellFilter: 'date:"MMMM"'
            },
          
            {
                field: 'gradeLevel',
                displayName: 'Grade Level',
                width: 90,
                enableCellEdit: false
            },
            {
                field: 'status',
                displayName: 'Status',
                width: 90,
                enableCellEdit: false
            },
        ],
        
        gridMenuCustomItems: [
          {
            title: 'Set STI',
            action: function ($event) {
              this.grid.element.toggleClass('rotated');
            },
            order: 10
          },
            {
            title: 'Set Status',
            action: function ($event) {
              this.grid.element.toggleClass('rotated');
            },
            order: 20
          },
              
        
        ],
        
        onRegisterApi: function( gridApi ) {
          $scope.gridApi = gridApi;
          $scope.gridApi.core.on.sortChanged( $scope, function( grid, sort ) {
            $scope.gridApi.core.notifyDataChange( uiGridConstants.dataChange.COLUMN );
          })
        }
        };
   
  /*  var initializeGrid = function(){
           samsRestService.authenticate().then(function(token){
             getEmployees();
           });
        };*/
 
        var getStudents = function(){
           samsRestService.getStudents().then(function(students){
             $scope.students = students.data;
           });
        };
 
        getStudents();
}]);
   
}(angular, schoolwork12));

